import * as React from "react";
import { Component } from "react";
import { NumericInput, NumericInputProps } from "../inputs/NumericInput";

export type State = {
    stringValue: string;
    numberValue: number;
};

const parse = (value: string, treatNullAsZero: boolean) => {
    if (value === "-" || value === "0" || !value) {
        if (treatNullAsZero) {
            return 0;
        }

        if (!value) {
            return null;
        }

        return 0;
    }

    return ep.numericUtility.parseLocal(value);
};

const format = (value: string | number, treatNullAsZero: boolean) => {
    if (!treatNullAsZero) {
        if (value === 0) {
            return "0";
        }
    }

    return ep.numericUtility.formatLocal(value || null);
};

export interface NumberInputProps extends NumericInputProps {
    treatNullAsZero?: boolean;
}

export class NumberInput extends Component<NumberInputProps, State> {
    constructor(props: NumberInputProps) {
        super(props);
        this.state = {
            stringValue: format(this.props.value, this.props.treatNullAsZero),
            numberValue: props.value as number,
        };
    }

    onChange = (value: string) => {
        this.setState({ stringValue: value });
        return this.props.onChangeAction(parse(value, this.props.treatNullAsZero));
    };

    onBlur = (event: any) => {
        const expectedValue = format(this.props.value, this.props.treatNullAsZero);
        if (expectedValue !== this.state.stringValue) {
            this.setState({ stringValue: expectedValue });
        }
        if (this.props.onBlurAction) {
            this.props.onBlurAction(event);
        }
    };

    render() {
        const { onChangeAction, value, onBlurAction, options, ...inputProps } = this.props;
        const numericOptions = {
            ...options,
            onPaste: this.onChange,
        } as typeof options;

        return (
            <NumericInput
                onChangeAction={this.onChange}
                value={this.state.stringValue}
                onBlurAction={this.onBlur}
                options={numericOptions}
                {...inputProps}
            />
        );
    }

    static getDerivedStateFromProps(nextProps: NumberInputProps, prevState: State) {
        const { treatNullAsZero } = nextProps;

        if (prevState.numberValue !== nextProps.value) {
            const value =
                parse(prevState.stringValue, treatNullAsZero) !== nextProps.value
                    ? format(nextProps.value, treatNullAsZero)
                    : prevState.stringValue;

            return {
                stringValue: value,
                numberValue: nextProps.value,
            } as State;
        }

        return null;
    }
}
